import { FC } from "react";
import SkeletonLoading from "src/components/skeleton-loading";
import { StyledAvt, StyledInfo, StyledLoadingWrapper } from "./style";

const ChatLoading: FC = () => {
    return (
        <StyledLoadingWrapper>
            {new Array(10).fill(Math.random()).map((i, index) => (
                <>
                    <SkeletonLoading height="60px" />

                    <StyledInfo key={`${i}-${String(index)}`}>
                        <SkeletonLoading height="20px" width="100px" />
                        <StyledAvt>
                            <SkeletonLoading
                                height="40px"
                                width="40px"
                                circle
                            />
                            <SkeletonLoading
                                height="20px"
                                width="100px"
                                style={{ marginLeft: "10px" }}
                            />
                        </StyledAvt>
                    </StyledInfo>
                    <br />
                </>
            ))}
        </StyledLoadingWrapper>
    );
};

export default ChatLoading;
